export default __webpack_public_path__ + "static/media/nosotros-5.a2d41143.jpg";